import React from "react";
import Layout from "@components/layout";
import SEO from "@components/seo";
import Controls from "@components/Controls/controls";
import UniplacesFullContainer from "@components/UniplacesFullContainer/uniplacesFullContainer";
import HeroSection from "@components/HeroSection/heroSection";
import TabsSection from "@components/TabsSection/tabsSection";
import { useIntl } from 'react-intl';

const TermsTemplate = ({
  data: {
    termsHeroHeading: {
      0: { text: heroHeading },
    },
    termsHeroSubheading: {
      0: { text: heroSubheading },
    },
    termsHeroImage,
    termsOfServiceTitle: {
      0: { text: termsOfServiceTitle },
    },
    termsOfServiceText,
    refundPolicyTitle: {
      0: { text: refundPolicyTitle },
    },
    refundPolicyText,
    referralProgrammeTitle: {
      0: { text: referralProgrammeTitle },
    },
    referralProgrammeText,
    privacyPolicyTitle: {
      0: { text: privacyPolicyTitle },
    },
    privacyPolicyText,
    partnersTitle: {
      0: { text: partnersTitle },
    },
    partnersText,
    dataPolicyTitle: {
      0: { text: dataPolicyTitle },
    },
    dataPolicyText,
    cookiesTitle: {
      0: { text: cookiesTitle },
    },
    cookiesText,
    reportingChannelTitle: {
      0: { text: reportingChannelTitle}
    },
    reportingChannelText
  },
  pageContext: { locale, activeTab, pageSlug },
}) => {
  const tabs = {
    'terms-of-service': {
      title: termsOfServiceTitle,
      text: termsOfServiceText
    },
    'refund-policy': {
      title: refundPolicyTitle,
      text: refundPolicyText
    },
    'referral-programme': {
      title: referralProgrammeTitle,
      text: referralProgrammeText
    },
    'privacy-policy': {
      title: privacyPolicyTitle,
      text: privacyPolicyText
    },
    'partners': {
      title: partnersTitle,
      text: partnersText
    },
    'data-policy': {
      title: dataPolicyTitle,
      text: dataPolicyText
    },
    'cookies': {
      title: cookiesTitle,
      text: cookiesText
    }
  };

  if (locale === 'pt') {
    tabs['reporting-channel'] = {
      title: reportingChannelTitle,
      text: reportingChannelText
    };
  }

  return (
    <Layout locale={locale}>
      <CustomSEO image={termsHeroImage} title={tabs[activeTab].title} locale={locale} />
      <HeroSection
        heroHeading={heroHeading}
        heroSubheading={heroSubheading}
        heroImage={termsHeroImage}
        height={240}
        lazyload={false}
      />
      <UniplacesFullContainer>
        <React.Fragment>
          <TabsSection
            tabs={tabs}
            defaultTab={activeTab ? activeTab : Object.keys(tabs)[0]}
            locale={locale}
            pageSlug={pageSlug}
          />
          <Controls />
        </React.Fragment>
      </UniplacesFullContainer>
    </Layout>
  );
};

const CustomSEO = ({
  image,
  title,
  locale,
}) => {
  const intl = useIntl();
  const metaTitle = `${intl.formatMessage({id: 'seo.terms.title'})} - ${title}`;
  const metaDescription = `${intl.formatMessage({id: 'seo.terms.description'})}`;

  return (
    <SEO
      title={metaTitle}
      description={metaDescription}
      imageUrl={image.url}
      lang={locale}
    />
  );
};

export default TermsTemplate;
